<template>
  <v-dialog
    v-model="dialog"
    max-width="400"
    persistent
    @keydown.esc="close"
  >
    <template #activator="{ on, attrs }">
      <span v-bind="attrs" v-on="on">
        <slot name="default" />
      </span>
    </template>
    <v-card class="about-dialog">
      <v-card-title class="py-2 pr-2 primary white--text">
        <v-row no-gutters>
          <v-col cols="11">{{ dialogTitle }}</v-col>
          <v-col cols="1" class="text-right">
            <v-btn dark small icon @click="close"><v-icon>mdi-close</v-icon></v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text class="pt-6 black--text" align="center">
        <v-img
          :alt="appName"
          class="mb-6"
          position="top left"
          :src="require(`../../assets/logo_color.png`)"
          width="40"
          height="40"
        />
        <h2 class="mb-1">{{ appName }}</h2>
        <h4 class="mb-4">{{ appVersion }}</h4>
        <span>
          Copyright &copy; {{ new Date().getFullYear() }} <a :href="authorURL" target="_blank" class="text-decoration-none">{{ authorName }}</a>.
          <br />
          {{ moreText }}
        </span>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import Vue from 'vue';
import intl from '@/utils/intl';

export default Vue.extend({
  data () {
    return {
      dialog: false,
      appName: process.env.VUE_APP_NAME,
      authorName: process.env.VUE_APP_AUTHOR_NAME,
      authorURL: process.env.VUE_APP_AUTHOR_URL,
    }
  },
  computed: {
    dialogTitle(): string {
      return intl.t('dialogs.about.title');
    },
    appVersion(): string {
      return intl.t('dialogs.about.version', process.env.VUE_APP_VERSION);
    },
    moreText(): string {
      return intl.t('dialogs.about.moreText');
    }
  },
  methods: {
    close(): void {
      this.dialog = false;
    }
  }
});
</script>

<style lang="scss">
.about-dialog {
  user-select: none;
}
</style>
